import { palette } from './system/palette';

export const action = {
  action: 'white',
  'action.primary': palette['blue-500'],
  'action.link': palette['blue-500'],
};
